export enum SearchFilter{
    ContractName = 0,
    ManagerName = 2,
    ManagerDeptName = 1
}

export enum SearchContractStatus{
    All = 0,
    Proceeding = 1,
    End = 2
}

export enum SearchContractExtend{
    All = 0,
    Extend = 1,
    None = 2
}

export enum WriteMode {
    Write = 0,
    Edit = 1,
    Reply = 2,
}

/**
 * 게시판 보기유형 타입
 * TA : 리스트형
 * AL : 앨범형
 * BL : 설문형
 * PV : 미리보기형
 * ADMIN : 관리자페이지
 */
export enum BoardViewType{
    TA= 'TA',
    AL= 'AL',
    BL= 'BL',
    PV= 'PV',
    ADMIN = 'ADMIN'
}